import React from 'react'
import ReactSelect from 'react-select'

const SelectWithAll = ({
  allowSelectAll,
  options,
  allOption = { label: 'Select all', value: '*' },
  onChange,
  placeholder,
  ...rest
}) => {
  if (allowSelectAll) {
    return (
      <ReactSelect
        {...rest}
        options={[allOption, ...options]}
        onChange={(selected, event) => {
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === allOption.value) {
              return onChange([allOption, ...options])
            }
            let result = []
            if (selected.length === options.length) {
              if (selected.includes(allOption)) {
                result = selected.filter((option) => option.value !== allOption.value)
              } else if (event.action === 'select-option') {
                result = [allOption, ...options]
              }
              return onChange(result)
            }
          }

          return onChange(selected)
        }}
      />
    )
  }

  return (
    <ReactSelect
      options={options}
      {...rest}
      placeholder={placeholder}
      onChange={(selected, event) => {
        if (selected !== null && selected.length > 0) {
          if (selected[selected.length - 1].value === allOption.value) {
            return onChange([allOption, ...options])
          }
        }

        return onChange(selected)
      }}
    />
  )
}

export default SelectWithAll
